import React, { useEffect, useRef, useState } from "react";
import "./groupWiseQuery.css";
import QueryHeader from "../Query Header/QueryHeader";
import QueryList from "../Query_List/QueryList";
import axios from "../../../axios";
import moment from "moment";
import { useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import GroupDetails from "./GroupDetails";
import QueryExpand from "../Query_List/QueryExpand";
import { toast } from "react-toastify";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const GroupWiseQuery = () => {
  const navigate = useNavigate()
  const currentUser = useSelector((state) => state.user.currentUser);
  const [click, setClick] = useState(false);
  const [query, setQuery] = useState([]);
  const [editQueryData, setEditQueryData] = useState({});
  const [expandQuery, setExpandQuery] = useState(false);
  const [dataFinal, setDataFinal] = useState();
  const [selectedQueryid, setSelectedQueryId] = useState(null)
  const [isGettingData, setIsGettingData] = useState(false);
  const [isProgress, setIsProgress] = useState(false);
  const [isPreventApiCall, setIsPreventApiCall] = useState(false)
  const lastPageRef = useRef(false);
  const loadingRef = useRef(false);
  const [filter, setFilter] = useState({
    date: null,
    tag: null,
    name: null,
    status: null,
    sortBy: -1,
    time: null,
    limit: 20,
    page: 1,
    searchClick: false,
  });
  const [delQuery, setDelQuery] = useState(false);
  const [group, setGroup] = useState({});
  const { state } = useLocation()
  const [click1, setClick1] = useState(false);
  const [initialQuery, setInititalQuery] = useState([]);
  const [isLastPage, setIsLastPage] = useState(false);

  // useEffect(() => {
  //   socket = io("http://localhost:3001");
  // }, []);

  useEffect(() => {
    let getGroup = async () => {
      setIsGettingData(true)
      try {
        let response = await axios.get(
          `/group/getById/${state.groupId}?isFullFledged=false`
        );
        response && setGroup(response.data.data);

      } catch (error) {
        console.log(error);
      }
      setIsGettingData(false)
    };
    getGroup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const handleRefresh = () => {
    setIsProgress(true);
    lastPageRef.current = false;
    loadingRef.current = false;

    setQuery([]);
    setFilter((prev) => ({
      ...prev,
      page: 1,
      searchClick: !prev.searchClick,
    }));
  };




  const getInitialQuery = async () => {
    setIsGettingData(true)
    try {
      let response = await axios.get(
        `/query/getForTeacher/groupId/${state.groupId}?_page=1&_limit=1&sortBy=${filter.sortBy}`
      );
      setInititalQuery(response.data.data);
      setIsGettingData(false)
    } catch (error) {
      console.log(error);
      setIsGettingData(false)
    }

  };

  useEffect(() => {
    getInitialQuery();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const handelInfiniteScroll = async () => {
  //   try {
  //     if (
  //       document.getElementById("inner-scrollable-div").clientHeight +
  //       document.getElementById("inner-scrollable-div").scrollTop +
  //       1 >=
  //       document.getElementById("inner-scrollable-div").scrollHeight
  //     ) {
  //       setFilter((prevState) => ({ ...prevState, page: prevState.page + 1 }));
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };




  const handelInfiniteScroll = async () => {
    try {
      if (
        document.getElementById("inner-scrollable-div").clientHeight +
        document.getElementById("inner-scrollable-div").scrollTop +
        1.9 >=
        document.getElementById("inner-scrollable-div").scrollHeight
      ) {
        if (!loadingRef.current && !lastPageRef.current) {
          setFilter((prevState) => ({ ...prevState, page: prevState.page + 1 }));
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const element = document.getElementById("inner-scrollable-div");

    if (element) {
      element.addEventListener("scroll", handelInfiniteScroll);
    }

    return () => {
      if (element) {
        element.removeEventListener("scroll", handelInfiniteScroll);
      }
    };
  }, []);

  const getQuery = async () => {
    const { page, limit, sortBy, status, name, tag, date, time } = filter;
    setIsProgress(true)
    try {
      let response = await axios.get(
        `/query/getForStudent/${currentUser?.id}/groupId/${state.groupId}?_page=${page}&_limit=${limit}&sortBy=${sortBy}` +
        `${status ? `&status=${status}` : ``}` +
        `${name
          ? `&name=${name}`
          : tag
            ? `&tags=${tag}`
            : date
              ? `&date=${date}`
              : ``
        }` +
        `${time && time !== null ? `&time=${time}` : ``}`
      );

      const totalFetchedQuery = query.length + response.data.data.length;
      const loadedQuery = Math.min(totalFetchedQuery, Number(response.data.total_query_count));

      if (response.data.data.length == 0 || loadedQuery === response.data.total_query_count) {
        lastPageRef.current = true
      }
      // setInProgress(false);
      if (page === 1) {
        setQuery(response.data.data);
      } else {
        setQuery((prev) => [...prev, ...response.data.data]);
      }
      // if (response.data.data.length > 0) {
      //   toast.info(`Loading Post (${loadedQuery + "/" + response.data.total_query_count})`, {
      //     position: "bottom-center",
      //   });
      // } else {
      //   toast.info(`Loaded Post (${loadedQuery + "/" + response.data.total_query_count})`, {
      //     position: "bottom-center",
      //   });
      // }

      // setQuery((prev) => [...prev, ...response.data.data]);
      // if (page === 1) {
      //   setInititalQuery((prev) => [...prev, ...response.data.data])
      // }
      // let loadedQuery = query.length + response.data.data.length;
      // if (response.data.data.length == 0 || loadedQuery === response.data.total_query_count) {
      //   setIsLastPage(true);
      // }
      // if (response.data.data.length > 0) {
      //   toast.info(`Loading Queries (${loadedQuery + "/" + response.data.total_query_count})`, {
      //     position: "bottom-center",
      //   });
      // }
      setIsProgress(false)
    } catch (error) {
      console.log(error);
      setIsProgress(false)
    }
  };

  useEffect(() => {
    getQuery();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delQuery, filter.searchClick, filter.status, filter.page, filter.sortBy, filter.time]);

  // useEffect(() => {
  //   setFilter((prevState) => ({ ...prevState, page: 1 }));
  //   setIsLastPage(false); // Reset last page flag
  // }, [page, status, searchClick, delQuery, limit]);

  function generateItems(query) {
    const sortedMessages = query.sort(
      (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
    );

    const messagesByDay = {};
    sortedMessages.forEach((message) => {
      const date = new Date(message.updated_at);
      const day = new Date(
        Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
      );
      if (messagesByDay[day]) {
        messagesByDay[day].push(message);
      } else {
        messagesByDay[day] = [message];
      }
    });
    return messagesByDay;
  }
  let data = generateItems(query);


  return (
    <div className="w-full h-full">
      {!expandQuery && (
        <QueryHeader
          editQueryData={editQueryData}
          setEditQueryData={setEditQueryData}
          setFilter={setFilter}
          filter={filter}
          change={setClick}
          query={query}
          setQuery={setQuery}
          groupData={group}
          click={click1}
          setClick={setClick1}
          initialQuery={initialQuery}
          setIsGettingData={setIsGettingData}
          setIsPreventApiCall={setIsPreventApiCall}
          handleRefresh={handleRefresh}
          getQuery={getQuery}
        />
      )}
      {/* Here added logic for loader */}
      {!click && !expandQuery && (
        <div>
          <div className="orange-scrollBar main_box w-full bg-white" id="inner-scrollable-div">
            {!initialQuery.length > 0 ? (
              <div
                style={{ marginTop: "14%" }}
                className="d-flex flex-column justify-content-center align-items-center"
              >
                <span className="no_query">
                  No queries yet. Be the first one to create a query.
                </span>
                <button
                  style={{ width: "15%", fontWeight: "600" }}
                  className="mt-2 btn btn-light creaeQueryBtn"
                  onClick={() => {
                    setClick1(true);
                    setClick(true);
                  }}
                >
                  Create Query
                </button>
              </div>
            ) : (
              (query?.length) > 0 ?
                (
                  <>
                    {Object.keys(data).map((day, index) => (
                      <div key={index}>
                        <span className=" mt-3 current_query">
                          {moment(day).calendar({
                            sameDay: "[Today]",
                            lastDay: "[Yesterday]",
                            lastWeek: "DD MMM YYYY ",
                            sameElse: "DD MMM YYYY",
                          })}
                        </span>
                        {data[day].map((item, index) => (
                          <QueryList
                            change={setClick}
                            setSelectedQueryId={setSelectedQueryId}
                            setEditQueryData={setEditQueryData}
                            setDelQuery={setDelQuery}
                            key={item.id || index}
                            setQuery={setQuery}
                            queries={item}
                            setExpandQuery={setExpandQuery}
                            setDataFinal={setDataFinal}
                            getQuery={getQuery}
                          />
                        ))}
                      </div>
                    ))}
                    {/* added loader */}
                    {isProgress && (
                      <img className="ongoing_loader" src="/gif/LoaderDot.gif" alt="loader" />
                    )}
                  </>
                ) : isProgress ? (
                  <img className="ongoing_loader" src="/gif/LoaderDot.gif" alt="loader" />
                ) : (
                  <div className="d-flex flex-column justify-content-center align-items-center w-100 h-100">
                    <span className="d-flex flex-column justify-content-center align-items-center">
                      No Query found
                    </span>
                  </div>
                )
            )}
          </div>
        </div>
      )}
      <div className="bg-white">
        {query.length !== 0 && expandQuery && (
          <QueryExpand
            refetch={() => { }}
            change={setClick}
            setEditQueryData={setEditQueryData}
            setQuery={setQuery}
            queries={dataFinal}
            setDelQuery={setDelQuery}
            setExpandQuery={setExpandQuery}
            setDataFinal={setDataFinal}
            groupData={group}
          />
        )}
      </div>
      {/* {query.length === 0 && <div
        style={{ marginTop: "14%" }}
        className="d-flex flex-column justify-content-center align-items-center"
      >
        <span className="no_query">
          No result found with this search.
        </span>
      </div>} */}
    </div>
  );
};

export default GroupWiseQuery;
